import { Switch } from '@gamma/ui/form-fields';
import { i18n } from '@investigator/shared/localization';
import {
  getCognitoRegion,
  isGovCloudRegion,
} from '@investigator/shared/utils/isGovCloud';
import { ExporterTLSInfoInput } from '../../queries';

export interface ExporterSslSwitchProps {
  name: string;
  value: ExporterTLSInfoInput;
  isUpdating: boolean;
  onChange: (...event: OnChangeSwitchProps[]) => void;
}

export interface OnChangeSwitchProps {
  verify_certificate: boolean;
}

const { forms, tooltips } = i18n.pages.alertExport;

export const ExporterSslSwitch = ({
  name,
  value,
  isUpdating,
  onChange,
}: ExporterSslSwitchProps) => {
  const region = getCognitoRegion();
  const isGov = isGovCloudRegion(region);

  return (
    <Switch
      name={name}
      label={forms.verifySsl}
      tooltip={isGov ? tooltips.govCloudSslRequired : tooltips.verifySsl}
      isChecked={value.verify_certificate}
      onChange={() =>
        onChange({
          verify_certificate: !value.verify_certificate,
        })
      }
      data-testid="sslSwitch"
      isDisabled={isUpdating || isGov}
    />
  );
};
